

























import { Component, Vue } from 'vue-property-decorator';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import { v4 as uuidv4 } from 'uuid';
import { DisplayOptions } from '@shared/interfaces/chart-interfaces';
import AccessesReportChart from '@access-control/charts/accesses-report-chart.vue';

@Component({
  components: {
    'bpc-content-wrapper': ContentWrapper,
    'bpc-accesses-report-chart': AccessesReportChart,
  },
})
export default class AccessesReportPage extends Vue {
  // Props

  // DATA
  // LIFECYCLE
  // created(){}
  // mounted() {}
  // updated(){}
  // destroyed(){}
  // COMPUTED

  displayOptions: DisplayOptions = {
    showChartBar: false,
    showChartLine: false,
    showChartArea: false,
    showChartPie: true,
  };

  get actionsPortalTarget() {
    return `accesses-report-actions-${uuidv4()}`;
  }
  get navigationPortalTarget() {
    return `accesses-report-navigation-${uuidv4()}`;
  }

  // METHODS

  // WATCHERS
}
